import React, { useState } from "react";
import {
  Paper,
  Typography,
  FormControl,
  Select,
  MenuItem,
  TextField,
  InputAdornment,
  Button,
  Box,
  FormControlLabel,
  RadioGroup,
  Radio,
} from "@mui/material";
import styles from "./payoutStatus.css";

const PayoutStatus = () => {
  const [payoutAccount, setPayoutAccount] = useState("Payout Account A");
  const [debitAmount, setDebitAmount] = useState("10000");
  const fees = 100;
  return (
    <Paper elevation={1} className={"tableContainer"}>
      {/* Balance */}
      <Typography className={"masterBalance"}>
        <span style={{ color: "#79747E", paddingRight: "5px" }}>
          Get payout status
        </span>
      </Typography>

      {/* Form */}
      <Box className={"formContainer"}>
       
        {/* <Typography className={"type"}>Select Mode</Typography>
        <FormControl component="fieldset" sx={{ marginLeft: 2 }}>
          <RadioGroup row defaultValue="collect" name="transaction-type">
            <FormControlLabel value="ref" control={<Radio />} label="Ref" />
            <FormControlLabel value="crn" control={<Radio />} label="CRN" />
            <FormControlLabel value="utr" control={<Radio />} label="UTR" />
          </RadioGroup>
        </FormControl> */}

        <TextField
          id="outlined-basic"
          label="Enter Collect Ref"
          variant="outlined"
          sx={{ borderRadius: "8px", backgroundColor: "#fff" }}
        />
        <Box className={"submitContainer"}>
          <Button
            variant="contained"
            className={"submitButton"}
            onClick={() => console.log("Submit clicked")}
          >
            Search
          </Button>
        </Box>
        <div className={"border"}>
          <Typography className={"statusCollect"}>
            <span style={{ color: "#79747E", paddingRight: "5px" }}>
              collect status
            </span>
          </Typography>
          <Box className={"row"}>
            <Typography className={"label"}>Collect ref</Typography>
            <Typography className={"colon"}>:</Typography>
            <Typography className={"value"}>₹{fees.toFixed(2)}</Typography>
          </Box>
          <Box className={"row"}>
            <Typography className={"label"}>UTR</Typography>
            <Typography className={"colon"}>:</Typography>
            <Typography className={"value"}>{"424414449279"}</Typography>
          </Box>
          <Box className={"row"}>
            <Typography className={"label"}>Status</Typography>
            <Typography className={"colon"}>:</Typography>
            <Typography className={"value"}>{"Processed"}</Typography>
          </Box>
          <Box className={"row"}>
            <Typography className={"label"}>Bank Resposne</Typography>
            <Typography className={"colon"}>:</Typography>
            <Typography className={"value"}>{"N/A"}</Typography>
          </Box>
        </div>
        {/* Submit */}
      </Box>
    </Paper>
  );
};

export default PayoutStatus;
